import React, { useState, useEffect } from "react";
import StartStocktakeSessionForm from "./StartStocktakeSessionForm";
import "./InventoryTransferForm.css";

const StocktakeTypeSelection = ({
  onClose,
  inventory,
  fetchProducts,
  userId,
  onSessionAdded,
}) => {
  const [mode, setMode] = useState(""); // "sku" | "location" 
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [sessionName, setSessionName] = useState(""); // common for all modes

  // 🧭 Fetch locations when needed
  useEffect(() => {
    if (mode === "location") {
      fetch("/api/locations")
        .then((res) => res.json())
        .then((data) => setLocations(data))
        .catch((err) => console.error("Error fetching locations:", err));
    }
  }, [mode]);


  // 📦 Start Stocktake by Location
  const handleStartByLocation = async () => {
    if (!selectedLocation) {
      alert("Please select a location first.");
      return;
    }
    if (!sessionName.trim()) {
      alert("Please enter a stocktake name.");
      return;
    }

    try {
      const res = await fetch(`/api/products/by-location/${selectedLocation}`);
      const locationItems = await res.json();

      if (!Array.isArray(locationItems) || locationItems.length === 0) {
        alert("No inventory items found for this location.");
        return;
      }

      const serial_numbers = locationItems.map((i) => i.serial_number);
      const payload = {
        name: sessionName.trim(),
        location_id: selectedLocation,
        serial_numbers,
        started_by_user_id: userId,
        compute_expected: true,
      };

      const create = await fetch("/api/stocktake/sessions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await create.json();
      if (create.ok) {
        alert(`Stocktake session "${sessionName}" created successfully.`);
        onSessionAdded?.();
        fetchProducts?.();
        onClose();
      } else {
        alert(data.error || "Failed to create stocktake session");
      }
    } catch (err) {
      console.error("Error creating stocktake by location:", err);
      alert("Server error, please try again.");
    }
  };




  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>

        {/* Selection Mode */}
        {!mode && (
          <>
            <h3>Select Stocktake Type</h3>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "20px" }}>
              <button onClick={() => setMode("sku")} className="submit-btn">By SKU List</button>
              <button onClick={() => setMode("location")} className="submit-btn">By Location</button>
            </div>
          </>
        )}

        {/* By SKU (manual selection) */}
        {mode === "sku" && (
          <StartStocktakeSessionForm
            onClose={onClose}
            inventory={inventory}
            fetchInventory={fetchProducts}
            userId={userId}
            onSessionAdded={onSessionAdded}
          />
        )}

        {/* By Location */}
        {mode === "location" && (
          <div style={{ marginTop: "20px" }}>
            <h3>Stocktake by Location</h3>

            <div className="form-group">
              <label id="add-user-label">Stocktake Name:</label>
              <input id="add-user-input"
                type="text"
                placeholder="Enter stocktake session name"
                value={sessionName}
                onChange={(e) => setSessionName(e.target.value)}
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </div>

            <div className="form-group">
              <label id="add-user-label">Select a location:</label>
              <select id="add-user-input"
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                style={{ width: "100%", padding: "8px", marginTop: "10px" }}
              >
                <option value="">Select...</option>
                {locations.map((loc) => (
                  <option key={loc.location_id} value={loc.location_id}>
                    {loc.location_name}
                  </option>
                ))}
              </select>
            </div>

            <button
              className="submit-btn"
              onClick={handleStartByLocation}
              style={{ marginTop: "20px" }}
            >
              Start Stocktake for this Location
            </button>
          </div>
        )}


      </div>
    </div>
  );
};

export default StocktakeTypeSelection;
